import TransactionStateLabel from "./TransactionStateLabel";

export default TransactionStateLabel;
